import templates from '../../api/templates'
import lodash from 'lodash';

const state = {
  general_templates: [], // 普通签名模板
  lastGeneralId: null, // 当前普通签名模板中最后一个的ID
  vip_templates: [], // 免审签名模板
  lastVipId: null, // 当前免审签名模板中最后一个的ID
  templateMap: [], // 模板类型
  mmsTemplateMap: [], // 超级模板类型
  tempSignMap: [], // 模板签名
  mms_templates: [], // 媒体短信模板
  activeTab: 'general'
};

const actions = {
  // 获取模板列表
  async getTemplates ({ commit }, payload) {
    const params = lodash.cloneDeep(payload);
    delete params.init;
    const response = await templates.getTemplates(params);
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_TEMPLATES', {
        report_type: payload.report_type,
        templates: data.templates,
        init: payload.init
      });
    }
  },
  // 删除一个模板
  async delTemplate ({ dispatch, commit, state }, payload) {
    const { report_type, id, index } = payload;
    const response = await templates.delTemplate(id);
    if (response.status === 204) {
      commit('DELETE_TEMPLATES', { report_type, index });
    }
  },
  // 删除超级模板
  async delMmsTemplate ({ dispatch, commit, state }, payload) {
    const { report_type, id, index } = payload;
    const response = await templates.delMmsTemplate(id);
    if (response.status === 200) {
      commit('DELETE_MMS_TEMPLATES', { report_type, index });
    }
  },
  // 更新回调地址
  async updateCallBack ({ dispatch, commit, state }, payload) {
    const response = await templates.updateCallBack(payload);
    const { data } = response
    if (response.status === 200) {
      dispatch('getTemplates', {
        report_type: 'vip',
        limit: 500,
        init: true
      })
      commit('UPDATE_GLOBAL_PROFILE', {
        profile: data,
        remain: data.remain,
        isPost: data.isPost
      });
    }
  },
  // 编辑模板
  async updateSingleCallBack ({ dispatch, commit }, payload) {
    const response = await templates.editTemplate(payload);
    if (response.status === 200) {
      return dispatch('getTemplates', {
        report_type: 'vip',
        limit: 500,
        init: true
      })
    }
  },

  // 媒体短信
  // 获取媒体模板列表
  async getMmsTemplates ({ commit }, payload) {
    const response = await templates.getMmsTemplates();
    if (response.status === 200) {
      const { data } = response;
      commit('UPDATE_MMS_TEMPLATES', {
        report_type: payload.report_type,
        templates: data.multimedia_templates,
        init: payload.init
      });
    }
  }
};

const mutations = {
  'UPDATE_TEMPLATES': (state, payload) => {
    if (payload.report_type === 'general') {
      const lastGeneral = (lodash.cloneDeep(payload.templates)).pop();
      state.lastGeneralId = lastGeneral ? lastGeneral.id : null;
      if (payload.init) {
        state.general_templates = payload.templates;
      } else {
        state.general_templates = (state.general_templates).concat(payload.templates);
      }
    } else {
      const lastVip = (lodash.cloneDeep(payload.templates)).pop();
      state.lastVipId = lastVip ? lastVip.id : null;
      if (payload.init) {
        state.vip_templates = payload.templates;
      } else {
        state.vip_templates = (state.vip_templates).concat(payload.templates);
      }
    }
    const templatesArr = state.general_templates.concat(state.vip_templates)
    state.templateMap = [];
    state.tempSignMap = [];
    let arr = [];
    templatesArr.forEach(item => {
      const obj = {}
      obj.label = item.id
      obj.value = item.id
      state.templateMap.push(obj)
      arr.push(item.temp_sign)
    });
    let newArr = arr.filter(i => i)
    state.tempSignMap = Array.from(new Set(newArr))
    state.templateMap.unshift({value: '', label: '全部'})
    state.tempSignMap.unshift('全部')
  },
  'DELETE_TEMPLATES': (state, payload) => {
    if (payload.report_type === 'general') {
      state.general_templates.splice(payload.index, 1);
    } else {
      state.vip_templates.splice(payload.index, 1);
    }
  },
  'CHOOSE_ACTIVETAB': (state, payload) => {
    state.activeTab = payload.activeTab;
  },
  'UPDATE_MMS_TEMPLATES': (state, payload) => {
    state.mms_templates = payload.templates;
    state.mmsTemplateMap = []
    payload.templates.forEach(item => {
      const obj = {}
      obj.label = item.id
      obj.value = item.id
      state.mmsTemplateMap.push(obj)
    });
  },
  'DELETE_MMS_TEMPLATES': (state, payload) => {
    state.mms_templates.splice(payload.index, 1);
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/templates.js